import React from 'react';
import { Flex, Space, Spin, Typography } from 'antd';
import Logo from '../../Components/SVGs/Logo';
import "./PageLoading.css"
const LoadingPage = () => {
    return (
        <Flex vertical align='center' justify='center'
            style={{
                height: '100vh',
                backgroundColor: 'var(--neutral-colorneutral-02-color-10)',
            }}
        >
            <Flex vertical className="logo_container">
                <Logo /> 
                <Space>
                    <Typography.Title level={2} style={{
                        color: "#6f605b",
                    }}>Telabite</Typography.Title>
                </Space>
            </Flex>
            <Spin
                size="large"
                style={{ color: 'orange' }}
            />
        </Flex>
    );
};

export default LoadingPage;
